import { useSelector } from 'react-redux';

import {
  getPredictedFailurePaydayChanged,
  getPredictedFailureWireIntention,
  getPredictedFundingFailureRequirement,
} from 'selectors/session';

import { getDashboardData } from 'features/payroll/redux/selectors/payroll';

export const usePredictedFundingFailureData = () => {
  const { payDate } = useSelector(getDashboardData);
  const predictedFundingFailureRequirement = useSelector(
    getPredictedFundingFailureRequirement
  );
  const predictedFailurePaydayChanged = useSelector(
    getPredictedFailurePaydayChanged
  );
  const predictedFailureWireIntention = useSelector(
    getPredictedFailureWireIntention
  );

  return {
    payDate,
    predictedFundingFailureRequirement,
    predictedFailurePaydayChanged,
    predictedFailureWireIntention,
  };
};
